import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  impersonateActionCreators,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import UsersListPage from '../components/UserListPage'
import {
  actionCreators,
  IUsersListState,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectTotalItems,
} from '../modules/userList'

export default connect(
  createStructuredSelector<
    ApplicationState,
    IUsersListState & ICurrentUserState
  >({
    error: selectError(),
    filterText: selectFilterText(),
    isLoading: selectIsLoading(),
    items: selectItems(),
    totalItems: selectTotalItems(),
    user: selectCurrentUser(),
  }),
  { ...actionCreators, ...impersonateActionCreators },
)(UsersListPage)
